<template>
	<CookieInformationBlockerCustom
		v-if="externalScript"
		:id="$vnode.key"
		:class="[
			'c-block-list-external-script-custom',
			{
				revert: revertExternalStyles,
			},
		]"
		:categories="computedCookies"
	>
		<PostscribeScript class="w-full" :html="externalScript" lazyload />
	</CookieInformationBlockerCustom>
</template>

<script>
import CookieInformationBlockerCustom from '~/components/main/CookieInformationBlockerCustom';
import PostscribeScript from '~/citi-baseline/components/PostScribeScript';

export default {
	name: 'BlockListExternalScriptCustom',
	components: { CookieInformationBlockerCustom, PostscribeScript },
	inheritAttrs: false,

	props: {
		revertExternalStyles: {
			type: Boolean,
			default: false,
		},
		externalScript: {
			type: String,
			required: true,
		},
		statistic: {
			type: Boolean,
			default: true,
		},
		functional: {
			type: Boolean,
			default: true,
		},
		marketing: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		computedCookies() {
			const { statistic, functional, marketing } = this;
			const cookies = { statistic, functional, marketing };
			return Object.keys(cookies).filter((e) => cookies[e]);
		},
	},
};
</script>
<style>
.c-block-list-external-script-custom.revert * {
	all: revert !important;
}
</style>
